import React from 'react';
import './Interests.css';
import { FaShieldAlt, FaFutbol, FaGlobeAmericas, FaChess, FaBook, FaMusic, FaMountain } from 'react-icons/fa';

interface Interest {
  name: string;
  description: string;
  icon: JSX.Element;
}

const interests: Interest[] = [
  {
    name: "Privacy & Cryptography",
    description: "",
    icon: <FaShieldAlt />
  },
  {
    name: "Football",
    description: "",
    icon: <FaFutbol />
  },
  {
    name: "Geopolitics",
    description: "",
    icon: <FaGlobeAmericas />
  },
  {
    name: "Strategy Games",
    description: "",
    icon: <FaChess />
  },
  {
    name: "Philosophy & Literature",
    description: "",
    icon: <FaBook />
  },
  {
    name: "Music",
    description: "",
    icon: <FaMusic />
  },
  {
    name: "Adventure Sports",
    description: "",
    icon: <FaMountain />
  }
];

const Interests: React.FC = () => {
  return (
    <div className="interests-container">
      <h1 className="interests-title">Personal Interests</h1>
      <p className="interests-subtitle">Beyond blockchain and technology, exploring diverse passions that shape my worldview</p>

      <div className="interests-grid">
        {interests.map((interest) => (
          <article key={interest.name} className="interest-card">
            <span className="interest-icon" aria-hidden="true">{interest.icon}</span>
            <h2 className="interest-name">{interest.name}</h2>
            {interest.description && (
              <p className="interest-description">{interest.description}</p>
            )}
          </article>
        ))}
      </div>
    </div>
  );
};

export default Interests;
